<div class="px-4 max-w-7xl mx-auto w-full flex flex-col gap-6">
  <!-- Photos card skeleton -->
  <div
    class="rounded-2xl border border-neutral-4 p-6 bg-white dark:bg-neutral-2 flex flex-col gap-4 shadow-sm"
  >
    <ngx-skeleton-loader
      [theme]="{ width: '100%', height: '320px', 'border-radius': '1rem', margin: '0' }"
      animation="pulse"
    />
    <div class="grid grid-cols-4 gap-3">
      @for (i of [1, 2, 3, 4]; track i) {
        <ngx-skeleton-loader
          [theme]="{ width: '100%', height: '80px', 'border-radius': '0.75rem', margin: '0' }"
          animation="pulse"
        />
      }
    </div>
  </div>
  <!-- Details card skeleton -->
  <div
    class="rounded-2xl border border-neutral-4 p-6 bg-white dark:bg-neutral-2 flex flex-col gap-4 shadow-sm"
  >
    <ngx-skeleton-loader
      [theme]="{ width: '50%', height: '28px', 'border-radius': '6px', margin: '0' }"
      animation="pulse"
    />
    <div class="grid grid-cols-2 sm:grid-cols-4 gap-4">
      @for (i of [1, 2, 3, 4]; track i) {
        <div class="p-4 bg-neutral-2 dark:bg-neutral-3 rounded-xl flex flex-col gap-2">
          <ngx-skeleton-loader
            [theme]="{ width: '60px', height: '12px', 'border-radius': '4px', margin: '0' }"
            animation="pulse"
          />
          <ngx-skeleton-loader
            [theme]="{ width: '100px', height: '20px', 'border-radius': '4px', margin: '0' }"
            animation="pulse"
          />
        </div>
      }
    </div>
  </div>
</div>
